import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../Redux/hooks';
import "./Banner.scss";
import { getKeyValuePair } from '../../utils/ContentOrConfigUtil';
import { allcontentOrConfigData, clearBannerInfo } from '../../Redux/Reducers/GlobalSlice';
import { CONTENT_OR_CONFIG_TABLE_MAPPING } from '../../utils/constants';
import { bannerStringGenerator } from '../../utils/validation';
export interface IBannerProps { };

const Banner: React.FunctionComponent<IBannerProps> = (props) => {
    const contentOrConfigData: any = useAppSelector(allcontentOrConfigData);
    const dispatch: any = useAppDispatch();
    let _role = useAppSelector((state: any) => state?.global?.role) || "";
    let _managedEquipment = useAppSelector((state: any) => state?.global?.managedEquipment);
    const [display, setDisplay] = useState(true);
    const handleCloseBtnClick = () => {
        setDisplay(!display);
        dispatch(clearBannerInfo());
    }
    return <>
        {display && <div className="banner" data-testid="banner">
            <div dangerouslySetInnerHTML={{
                __html: getKeyValuePair(contentOrConfigData, CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.banner,
                    bannerStringGenerator(_role, _managedEquipment))
            }} className='banner-content' />
            <div className='banner-close-btn' onClick={handleCloseBtnClick} data-testid="bannerclosebutton">X</div>
        </div>}
    </>
}
export default Banner;